import { render, staticRenderFns } from "./WallpaperSettings.vue?vue&type=template&id=b3d35144&"
import script from "./WallpaperSettings.vue?vue&type=script&lang=js&"
export * from "./WallpaperSettings.vue?vue&type=script&lang=js&"
import style0 from "./WallpaperSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports